import _ from "lodash";

export class CreateClubModel {
  constructor(model) {
    this.club = model.selectedClub;
    this.startYear = model.startYear;
    this.endYear = model.endYear;
    this.teams = model.teams;
  }
  // Getter
  get Validate() {
    return this.validateModel();
  }
  // Method
  validate() {
    const errors = {};
    if (!this.club || _.isEmpty(this.club)) {
      errors.club = {
        message: "Required",
        hasError: true
      };
    }
    if (!this.startYear) {
      errors.startYear = {
        message: "Required",
        hasError: true
      };
    }
    if (!this.teams || _.isEmpty(this.teams)) {
      errors.teams = {
        message: "Please select at least one team",
        hasError: true
      };
    }
    return errors;
  }
}



// WEBPACK FOOTER //
// ./src/models/club/create.club.model.js